;(() => {
  const accordions = document.querySelectorAll('button.accordion-button')

  accordions.forEach((accordion) => {
    accordion.addEventListener('click', () => {
      accordion.classList.toggle('active')
      const panel = accordion.nextElementSibling
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px'
      }
    })

    if (accordion.classList.contains('default-active')) {
      accordion.click()
    }
  })
})()
